// extracted by mini-css-extract-plugin
module.exports = {"button":"Password_button__2KWGc","buttons":"Password_buttons__1qh4X"};